<template>
  <div style="background-color: white">
    <div class="no-display">
      <v-btn @click="prevPage" color="primary" class="ml-5 mr-5" :disabled="currentPage === 1">Previous Page</v-btn>
      <v-btn @click="nextPage" color="primary" class="ml-5 mr-5" :disabled="currentPage === totalPages">Next
        Page</v-btn>
      <v-btn @click="print" color="primary" class="ml-5 mr-5" warning>Print</v-btn>
    </div>

    <div v-for="(stud_data, ind) in displayedItems" :key="ind">
      <div class="" style="background-color: white">
        <div style="width: 19rem">
          <div>
            <v-row style="background-color: #623e7e;  padding-top: 42px">
              <v-col cols="12" class="pa-0">
                <div style="
                      display: flex;
                      align-items: flex-end;
                      justify-content: center;
                      padding: 0 22px;
                      height: 100%;
                      margin-left: 21px;
                    ">
                  <div style="display: flex; align-items: flex-end">
                    <img :src="common_data.logo" style="width: 77px; height: 77px" alt="logo" />
                  </div>

                  <div style="
                    width: 100%;
                    font-size: 14px;
                    align-items: center;
                  ">
                    <b>
                      <span style="
                            text-transform: uppercase;
                            line-height: 1;
                            color: white;
                            font-family: 'Vogue';
                            font-size: 13px;
                          ">
                        {{ common_data.school_name }}
                      </span>
                    </b>

                    <div style="
            border-bottom: 1px solid white;
            width: 90%;
            margin-bottom: -5px;
          "></div>

                    <span class="mdi mdi-map-marker" v-if="org_id == '1'" style="color: white; font-size: 10px">
                      {{ common_data.heading }}
                    </span>

                    <span class="mdi mdi-map-marker" v-else style="color: white; font-size: 9px">
                      {{ common_data.heading }}
                    </span>

                    <div style="
            border-bottom: 1px solid white;
            width: 90%;
            margin-bottom: -5px;
          "></div>

                    <span class="mdi mdi-phone" style="color: white; font-size: 10px">
                     {{common_data.school_contact}}
                    </span>

                    <div style="
            border-bottom: 1px solid white;
            width: 90%;
            margin-bottom: -5px;
          "></div>

                    <span class="mdi mdi-web" style="color: white; font-size: 10px">
                      {{ common_data.website }}
                    </span>
                  </div>
                </div>
              </v-col>
            </v-row>
            <div class="row" style="
                background-color: #f5e8ca;
                height: 4px;
                justify-content: center;
              "></div>
            <div class="row" style="
                justify-content: center;
                margin: 5px 0;
                margin-left: 2px;
              " v-if="stud_data.icard_temp.child_photo">
              <img style="border: 3px solid #623e7e" v-if="stud_data.icard_temp.child_photo.field_value"
                :src="stud_data.icard_temp.child_photo.field_value" width="120px" height="120px" />
            </div>
            <div class="row" style="
                background-color: #623e7e;
                height: 25px;
                justify-content: center;
              ">
              <h3 v-if="aadhar_icardname == true" style="color: white; margin-left: 12px">
                <span v-if="stud_data.icard_temp.name_as_per_aadhar">{{
                  stud_data.icard_temp.name_as_per_aadhar
                  }}</span>
                <span v-else>{{
                  stud_data.icard_temp.firstname.field_value
                }}&nbsp;&nbsp;&nbsp;&nbsp;{{
                    stud_data.icard_temp.lastname.field_value
                  }}</span>
              </h3>
              <h3 v-else style="color: white; margin-left: 12px">
                <span v-if="stud_data.icard_temp.firstname">
                  {{ stud_data.icard_temp.firstname.field_value }}
                </span>
                <span v-if="stud_data.icard_temp.middlename">
                  {{ stud_data.icard_temp.middlename.field_value }}
                </span>
                <span v-if="stud_data.icard_temp.lastname">
                  {{ stud_data.icard_temp.lastname.field_value }}
                </span>
              </h3>
            </div>
            <div style="position: relative">
              <div class="row" style="
                  justify-content: center;
                  font-size: 14px;
                  margin-left: 17px;
                ">
                <div class="col-6" style="padding: 3px 20px;">
                  <span> Std.: <b> {{ stud_data.icard_temp.std }} </b></span>
                </div>
                <div class="col-6" style="padding: 3px 20px;">
                  <span> Div.: <b> {{ stud_data.icard_temp.div }} </b></span>
                </div>
                <div class="col-12" style="padding: 3px 20px;">
                  <span> PRN No.: <b> {{ stud_data.icard_temp.grno }} </b></span>
                </div>

                <div v-if="stud_data.icard_temp.emergency_contact_number" class="col-12" style="padding: 3px 20px;">
                  <span> Emergency Contact No.: </span><span>
                    <b>{{
                      stud_data.icard_temp.emergency_contact_number
                        .field_value
                    }}
                    </b></span>
                </div>
                <center>
                  <qrcode-vue class="pt-1" style="margin-left: -20px" :value="stud_data.icard_temp.grno"
                    :size="75"></qrcode-vue>
                </center>
              </div>
              <div class="row" style="
                  background-color: #623e7e;
                  height: 41px;
                  position: relative;
                "></div>
            </div>
          </div>
          <div class="pagebreak">
            <v-row style="background-color: #623e7e;  padding-top: 42px">
              <v-col cols="12" class="pa-0">
                <div style="
                    display: flex;
                    align-items: flex-end;
                    justify-content: center;
                    padding: 0 22px;
                    height: 100%;
                    margin-left: 21px;
                  ">
                  <div style="display: flex; align-items: flex-end">
                    <img :src="common_data.logo" style="width: 77px; height: 77px" alt="logo" />
                  </div>

                  <div style="
                    width: 100%;
                    font-size: 14px;
                    align-items: center;
                  ">
                    <b>
                      <span style="
                            text-transform: uppercase;
                            line-height: 1;
                            color: white;
                            font-family: 'Vogue';
                            font-size: 13px;
                          ">
                        {{ common_data.school_name }}
                      </span>
                    </b>

                    <div style="
                        border-bottom: 1px solid white;
                        width: 90%;
                        margin-bottom: -5px;
                      "></div>

                    <span class="mdi mdi-map-marker" v-if="org_id == '1'" style="color: white; font-size: 10px">
                      {{ common_data.heading }}
                    </span>

                    <span class="mdi mdi-map-marker" v-else style="color: white; font-size: 9px">
                      {{ common_data.heading }}
                    </span>

                    <div style="
                        border-bottom: 1px solid white;
                        width: 90%;
                        margin-bottom: -5px;
                      "></div>

                    <span class="mdi mdi-phone" style="color: white; font-size: 10px">
                     {{common_data.school_contact}}
                    </span>

                    <div style="
                      border-bottom: 1px solid white;
                      width: 90%;
                      margin-bottom: -5px;
                    "></div>

                    <span class="mdi mdi-web" style="color: white; font-size: 10px">
                      {{ common_data.website }}
                    </span>
                  </div>
                </div>
              </v-col>
            </v-row>
            <div class="row" style="
                background-color: #f5e8ca;
                height: 5px;
                justify-content: center;
              "></div>
            <div class="row" style="justify-content: center; margin-top: 7px">
              <span style="font-weight: 500"> Parent Details</span>
            </div>
            <div style="padding: 0 20px;">
              <div class="row" style="justify-content: center; margin-top: 16px">
                <div>
                  <span style="position: relative" v-if="stud_data.icard_temp.father_photo.field_value">
                    <center>
                      <span v-if="stud_data.icard_temp.father_photo.field_value" style="
                        position: absolute;
                        border-top: 5px solid #f5e8ca;
                        border-left: 5px solid #f5e8ca;
                        width: 35px;
                        height: 35px;
                        top: -5px;
                        left: 0;
                      "></span>
                      <img style="border: 3px solid #623e7e" v-if="stud_data.icard_temp.father_photo.field_value"
                        :src="stud_data.icard_temp.father_photo.field_value" width="100px" height="100px" />
                      <span v-if="stud_data.icard_temp.father_photo.field_value" style="
                        position: absolute;
                        border-right: 5px solid #f5e8ca;
                        border-bottom: 5px solid #f5e8ca;
                        width: 35px;
                        height: 35px;
                        bottom: 1.9px;
                        right: 0%;
                      "></span>
                    </center>
                  </span>
                  <span style="position: relative" v-else>
                    <center>
                      <span style="
                        position: absolute;
                        border-top: 5px solid #f5e8ca;
                        border-left: 5px solid #f5e8ca;
                        width: 35px;
                        height: 35px;
                        top: -5px;
                        left: -5px;
                      "></span>
                      <img style="border: 3px solid #623e7e" alt="" :src="stud_data.icard_temp.father_photo.field_value"
                        width="110px" height="110px" />
                      <span style="
                        position: absolute;
                        border-right: 5px solid #f5e8ca;
                        border-bottom: 5px solid #f5e8ca;
                        width: 35px;
                        height: 35px;
                        bottom: 1.9px;
                        right: -20%;
                      "></span>
                    </center>
                  </span>
                  <span class="text-center">
                    <div style="
                      color: #623e7e;
                      height: 48px;
                      font-size: 12px;
                      line-height: 12px;
                      width: 110px;
                      font-weight: bold;
                    ">
                      <span v-if="stud_data.icard_temp.father_fullname">{{ stud_data.icard_temp.father_fullname.field_value }}</span>
                    </div>
                  </span>

                  <div class="text-center" style="margin-top: -10px" v-if="stud_data.icard_temp.father_mobile_no">
                    <h5>
                      <span style="font-weight: 400; font-size: 14px">
                        Contact No. : </span><br />
                      <span style="font-size: 12px">{{
                        stud_data.icard_temp.father_mobile_no.field_value
                      }}</span>
                    </h5>
                  </div>
                </div>
                <div style="
                  border-right: #623e7e 1.9px dotted;
                  margin: 0 15px;
                "></div>
                <div style="width: 6rem; margin-left: 0px">
                  <span style="position: relative" v-if="stud_data.icard_temp.mother_photo.field_value">
                    <center>
                      <span v-if="stud_data.icard_temp.mother_photo.field_value" style="
                        position: absolute;
                        border-top: 5px solid #f5e8ca;
                        border-left: 5px solid #f5e8ca;
                        width: 35px;
                        height: 35px;
                        top: -5px;
                        left: -5px;
                      "></span>
                      <img style="border: 3px solid #623e7e" v-if="stud_data.icard_temp.mother_photo.field_value"
                        :src="stud_data.icard_temp.mother_photo.field_value" width="100px" height="100px" />
                      <span v-if="stud_data.icard_temp.mother_photo.field_value" style="
                        position: absolute;
                        border-right: 5px solid #f5e8ca;
                        border-bottom: 5px solid #f5e8ca;
                        width: 35px;
                        height: 35px;
                        bottom: 1.9px;
                        right: -10%;
                      "></span>
                    </center>
                  </span>
                  <span style="position: relative" v-else>
                    <center>
                      <span style="
                        position: absolute;
                        border-top: 5px solid #f5e8ca;
                        border-left: 5px solid #f5e8ca;
                        width: 35px;
                        height: 35px;
                        top: -5px;
                        left: -5px;
                      "></span>
                      <img style="border: 3px solid #623e7e" :src="stud_data.icard_temp.mother_photo.field_value" alt=""
                        width="110px" height="110px" />
                      <span style="
                        position: absolute;
                        border-right: 5px solid #f5e8ca;
                        border-bottom: 5px solid #f5e8ca;
                        width: 35px;
                        height: 35px;
                        bottom: 1.9px;
                        right: -20%;
                      "></span>
                    </center>
                  </span>
                  <span class="text-center">
                    <div style="
                      color: #623e7e;
                      height: 48px;
                      font-size: 12px;
                      line-height: 12px;
                      width: 110px;
                      font-weight: bold;
                    ">
                      <span v-if="stud_data.icard_temp.mother_fullname">{{ stud_data.icard_temp.mother_fullname.field_value }}</span>
                    </div>
                  </span>

                  <div class="text-center" style="margin-top: -10px" v-if="stud_data.icard_temp.mother_mobile_no">
                    <h5>
                      <span style="font-weight: 400; font-size: 14px">
                        Contact No. : </span><br />
                      <span style="font-size: 12px">{{
                        stud_data.icard_temp.mother_mobile_no.field_value
                      }}</span>
                    </h5>
                  </div>
                </div>
              </div>
              <div v-if="stud_data.icard_temp.address_for_icard" class="col-12" style="
                margin: 0px 8px 7px 13px;
                font-size: 12px;
                height: 13px;
                padding-right: 14px;
              ">
                <span> Address: </span>
                <span>
                  <b>{{ stud_data.icard_temp.address_for_icard.field_value }}</b>
                </span>
              </div>
            </div>
            <div class="row" style="
                background-color: #623e7e;
                height: 45px;
                margin-top: 55px;
              "></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import VueBarcode from "vue-barcode";
import QrcodeVue from "qrcode.vue";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  components: {
    barcode: VueBarcode,
    QrcodeVue,
  },
  data: () => ({
    comp_load: false,
    stud_list: null,
    radios: null,
    stud_data: null,
    child_data: null,
    icard_data: [],
    std: null,
    div: null,
    common_data: null,
    status: null,
    itemsPerPage: 0, // Number of items per page
    currentPage: 1,
    aadhar_icardname: false,
  }),
  mounted() {
    this.std = localStorage.getItem("icard_std_id");
    this.div = localStorage.getItem("icard_div_id");
    this.status = localStorage.getItem("icard_learner_status");
    this.itemsPerPage = localStorage.getItem("itemsPerPage");
    this.org_id = localStorage.getItem("EPS-org-id");
    this.icardGenerateStudent();
  },
  computed: {
    totalPages() {
      return Math.ceil(this.icard_data.length / this.itemsPerPage);
    },
    displayedItems() {
      const start = (this.currentPage - 1) * parseInt(this.itemsPerPage);
      const end = start + parseInt(this.itemsPerPage);
      return this.icard_data.slice(start, end);
    },
  },

  methods: {
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
    onload() { },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    icardGenerateStudent() {
      const data = {
        std: this.std,
        div: this.div,
        status: this.status,
        usertype: "Student",
      };
      this.comp_load = false;
      axios
        .post("/Icard/bulkicardGenerateStudent", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.icard_data = res.data.icard_data;
            this.common_data = res.data.common_data;
            this.aadhar_icardname = res.data.Aadhar_Name_For_Icard;
          } else {
            alert(res.data.snackbar);
          }
          this.comp_load = true;
        })
        .catch((error) => {
          alert("Somthing went wrong!!!");
          this.comp_load = false;
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
  },
};
</script>

<style scoped>
@media print {
  .pagebreak {
    page-break-before: always !important;
  }

  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }

  @page {
    margin: -1.2645833mm;
    size: 58mm 91mm;
  }
}
</style>
